import React from 'react'
import PageBlocks from '../cms-page-blocks/list'

const InstitutionLandingPage = (props) => {
  return (
    <PageBlocks
      title='Institution Landing Page Blocks'
      target='cms_fixed_page_blocks'
      cmsPageProp='page'
      cmsPageId='institution_landing_page'
      route={props.route}
    />
  )
}

export default InstitutionLandingPage
